(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shopoflux-coverflow"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('sf-coverflow')) {
  customElements.define('sf-coverflow', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.stage = this.querySelector('.sf-cf');
      this.cards = [...this.querySelectorAll('.sf-cf-card')];
      this.panels = [...this.querySelectorAll('.sf-cf-panel')];
      this.dots = [...this.querySelectorAll('.sf-cf-dots button')];
      this.pauseButton = this.querySelector('.sf-cf-pause');
      this.active = 0;
      this.manualPause = false;
      this.hoverPause = false;
      this.focusPause = false;
      this.visible = true;
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 1000px)');
      this.on(this.mobile, 'change', () => this.show(this.active), signal);
      this.speed = Math.max(3000, Number(this.dataset.speed) || 3000);
      this.on(this.querySelector('[data-prev]'), 'click', () => this.go(-1), signal);
      this.on(this.querySelector('[data-next]'), 'click', () => this.go(1), signal);
      this.cards.forEach((card, i) => this.on(card, 'click', () => {if(i===this.active && card.dataset.url){window.location.href=card.dataset.url;}else{this.show(i);}}, signal));
      this.panels.forEach((panel,i)=>panel.querySelectorAll('[data-color-index]').forEach(button=>this.on(button,'click',()=>this.selectColor(i,Number(button.dataset.colorIndex)),signal)));
      this.dots.forEach((dot, i) => this.on(dot, 'click', () => this.show(i), signal));
      this.on(this.pauseButton, 'click', () => {
        this.manualPause = !this.manualPause;
        this.pauseButton.setAttribute('aria-label', this.manualPause ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.pauseButton.setAttribute('aria-pressed', String(this.manualPause));
        this.schedule();
      }, signal);
      this.on(this, 'pointerenter', (e) => { if(e.pointerType === 'mouse'){this.hoverPause = true;this.schedule();} }, signal);
      this.on(this, 'pointerleave', () => {this.hoverPause = false;this.stage.style.setProperty('--sf-x',0);this.stage.style.setProperty('--sf-y',0);this.schedule();}, signal);
      this.on(this, 'focusin', () => {this.focusPause = true;this.schedule();}, signal);
      this.on(this, 'focusout', (e) => {if(!this.contains(e.relatedTarget)){this.focusPause = false;this.schedule();}}, signal);
      this.on(this.stage, 'pointermove', (e) => {
        if(this.reduced.matches || e.pointerType !== 'mouse') return;
        const r = this.stage.getBoundingClientRect();
        this.stage.style.setProperty('--sf-x', ((e.clientX-r.left)/r.width-.5).toFixed(3));
        this.stage.style.setProperty('--sf-y', ((e.clientY-r.top)/r.height-.5).toFixed(3));
      }, signal);
      this.on(this.stage, 'touchstart', (e) => {this.tx=e.touches[0].clientX;this.ty=e.touches[0].clientY;}, signal);
      this.on(this.stage, 'touchend', (e) => {
        const dx=e.changedTouches[0].clientX-this.tx,dy=e.changedTouches[0].clientY-this.ty;
        if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)) this.go(dx<0 ? 1 : -1);
      }, signal);
      this.on(this, 'keydown', (e) => {if(e.key==='ArrowRight'){e.preventDefault();this.go(1);}if(e.key==='ArrowLeft'){e.preventDefault();this.go(-1);}}, signal);
      this.on(document, 'visibilitychange', () => this.schedule(), signal);
      this.on(this.reduced, 'change', () => this.schedule(), signal);
      this.on(document, 'shopify:block:select', (e) => {
        const i=this.cards.findIndex(c=>c.dataset.blockId===e.detail?.blockId);
        if(i>=0){this.manualPause=true;this.pauseButton.setAttribute('aria-label',this.dataset.playLabel);this.pauseButton.setAttribute('aria-pressed','true');this.show(i);}
      }, signal);
      this.observer = new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.schedule();});
      this.observer.observe(this);
      this.show(0);
    }
    on(el,event,fn,signal){if(el) el.addEventListener(event,fn,{signal,passive:event.startsWith('touch')});}
    go(direction){if(this.cards.length>1)this.show((this.active+direction+this.cards.length)%this.cards.length);}
    show(i){
      const n=this.cards.length;
      if(!n) return;
      this.active=i;
      this.cards.forEach((card,j)=>{
        const role=j===i?'center':j===(i+n-1)%n?'left':j===(i+1)%n?'right':'hidden';
        card.dataset.role=role;
        const hidden=role==='hidden' || (this.mobile.matches && role!=='center');
        card.tabIndex=hidden?-1:0;
        card.setAttribute('aria-hidden',String(hidden));
        card.setAttribute('aria-pressed',String(j===i));
      });
      this.panels.forEach((panel,j)=>panel.hidden=j!==i);
      this.dots.forEach((dot,j)=>dot.setAttribute('aria-pressed',String(j===i)));
      this.querySelector('[data-word]').textContent=this.cards[i].dataset.word;
      this.stage.style.setProperty('--sf-word-length', Math.max(3,this.cards[i].dataset.word.length));
      this.querySelector('[data-count]').textContent=String(i+1).padStart(2,'0');
      this.stage.style.setProperty('--sf-bg',this.cards[i].dataset.bg);
      this.schedule();
    }
    selectColor(slide,index){
      const card=this.cards[slide],panel=this.panels[slide];
      const images=[...card.querySelectorAll('.sf-cf-color-img')];
      const buttons=[...panel.querySelectorAll('[data-color-index]')];
      if(!images[index])return;
      images.forEach((image,j)=>image.dataset.colorRole=j===index?'center':j===(index+1)%images.length?'left':'right');
      buttons.forEach((button,j)=>button.setAttribute('aria-pressed',String(j===index)));
      const url=buttons[index].dataset.colorUrl;
      card.dataset.url=url;card.setAttribute('aria-label',card.dataset.word+' — '+buttons[index].textContent.trim());
      const destination=panel.querySelector('.sf-cf-link');if(destination&&url)destination.href=url;
      this.schedule();
    }
    schedule(){
      clearTimeout(this.timer);
      if(this.cards.length>1 && this.dataset.autoplay==='true' && !this.manualPause && !this.hoverPause && !this.focusPause && this.visible && !document.hidden && !this.reduced.matches){this.timer=setTimeout(()=>this.go(1),this.speed);}
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();this.ready=false;}
  });
}


  } catch(e) { console.error(e); }
})();
})();
